/// <reference types="@angular/localize" />

// This line is a triple-slash directive that references the type definitions for @angular/localize.
// It's used to enable Angular's internationalization (i18n) features in TypeScript.
// This allows the use of i18n functions and types without explicitly importing them.

import { bootstrapApplication } from '@angular/platform-browser';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const matIconRegistry = appRef.injector.get(MatIconRegistry);
    const domSanitizer = appRef.injector.get(DomSanitizer);
    matIconRegistry.setDefaultFontSetClass('material-icons');
    matIconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'),
    );
  })
  .catch((err) => console.error(err));
